import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Table, TableBody, TableCell, TableHeaderCell, TableRow, Button, Form, Header, Loader,Icon } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { useStore } from "../../../app/stores/store";

interface RestorationProductivityData {
    employee_Id: string;
    employee_Name: string;
    project_Name: string;
    approval_Frames: string;
    total_Hours: string;
    dof: string;
    current: string;
    tenure: string;
    efficency: string;
    est_Hour: string;
    total_Framess: string;
    target: string;
    actualTarget: string;
    productivity_percentage: string;
    sum_of_Rejected_Frames: string;
    quality_percentage: string;
    artifacts_Rejected_Frames: string;
    artifacts_Rejection_percentage: string;
//   [key: string]: string | number|boolean;
}
function RestorationProductivityReport() {
    const { RestorationStore, PivotStore } = useStore();
    const [loadData, setLoadData] = useState<RestorationProductivityData[]>([]);
    const currentDate = new Date();
    const [startDate, setStartDate] = useState(() => moment(currentDate).startOf('month').format('MM-DD-YYYY'));
    const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
    const ReportMonth = moment(endDate, 'MM-DD-YYYY').format('MMM-YYYY');
    const [loading, setLoader] = useState<boolean>(true);
    const setDate = (data: any, type: string) => {
      try {
        if (type === 'start') {
          setStartDate(moment(data).format('MM-DD-YYYY'));
        } else {
          setEndDate(moment(data).format('MM-DD-YYYY'));
        }
      } catch (error) {
        toast.error('Error fetching Date');
      }
    };
  
    const ApiCall = async () => {
      try {
          setLoader(true);
        await RestorationStore.RestorationProductivityAPI(startDate, endDate);
        setLoadData(RestorationStore.RestorationProductivity);
        setLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        toast.error('Error fetching data');
      }
      
    };
    useEffect(() => {
      ApiCall();
      // eslint-disable-next-line
    }, [])
    const CsvConvert=()=>{
      const rows=[];
      
      const titleCodeRow=[
          'Employee Id',
          'Employee Name',
          'Project Name',
          'Approval Frames',
          'Total Hours',
          'DOF',
          'Current',
          'Tenure',
          'Efficency',
          'Est Hour',
          'Total Framess',
          'Target',
          'Actual Target',
          'Productivity Percentage',
          'Total Rejected Frames',
          'Quality Percentage',
          'Artifacts Rejected Frames',
          'Artifacts Rejection Percentage',
      ];
     
      rows.push(titleCodeRow.join(','));
      loadData.forEach(item => {
          const values = Object.values(item);
          rows.push(values.join(','));
      });
      const csvContent = rows.join('\n');
      return csvContent;
    }
    const handleDownload = () => {
      const csvContent = CsvConvert();
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${ReportMonth}_MonthProductivityTitleWiseBreakup.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  };
  
    return (
      <>
        <div className="title-wise-table" >
          <Header> Title Wise Monthly Productivity Report</Header>
          <div style={{ display: 'flex', alignItems: 'center', position: 'sticky', top: 0, zIndex: 2, background: 'white' }}>
            <div style={{ display: 'flex', alignItems: 'center'}}>
              <h4 > From Date  </h4>
              <DatePicker
                placeholderText="From Date"
                value={
                  startDate
                    ? PivotStore.dateFormat(
                      moment(startDate).format('MM-DD-YYYY'),
                    )
                    : ''
                }
                className="date-picker-style"
                showMonthDropdown
                showYearDropdown
                locale={'en'}
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={15}
                maxDate={moment().toDate()}
                scrollableYearDropdown
                onChange={(date: any) => setDate(date, 'start')}
                popperProps={{ strategy: 'fixed' }}
              />
              <Form.Field required={true}>
                
                  <div style={{ display: 'flex', alignItems: 'center'}}>
                    <h4> To Date{' '} </h4>
                    <DatePicker
                      placeholderText="To Date"
                      value={
                        endDate
                          ? PivotStore.dateFormat(
                            moment(endDate).format('MM-DD-YYYY'),
                          )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      maxDate={moment().add(0, 'days').toDate()}
                      scrollableYearDropdown
                      onChange={(date: any) => setDate(date, 'end')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                
                </div>
              </Form.Field>
              </div>
              <div style={{ display: 'flex', alignItems: 'center'}}>
              <Form.Field>
                <Button
                  primary
                  onClick={ApiCall}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '20px',
                    paddingBottom: '10px',
                  }}
                >
                  View Report
                </Button>
              </Form.Field>
              </div>
              <div style={{ display: 'flex', alignItems: 'center'}}>
              <Form.Field>
                  <div style={{ display: 'flex', alignItems: 'center'}}>
                    {loadData.length !== 0 && (<Button onClick={handleDownload}><Icon className='download'/></Button>)}
                    </div>
                </Form.Field>
            </div>
        
          </div>
          {loading ? <Loader active inline='centered' > Loading </Loader>:
          <div style={{maxHeight: '60vh', overflowY: 'auto' }}>
            <Table className='celled padded'>
              <Table.Header style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                <Table.Row>
                  <TableHeaderCell>Employee Id</TableHeaderCell>
                  <TableHeaderCell>Employee Name</TableHeaderCell>
                  <TableHeaderCell>Project Name</TableHeaderCell>
                  <TableHeaderCell>Approval Frames</TableHeaderCell>
                  <TableHeaderCell>Total Hours</TableHeaderCell>
                  <TableHeaderCell>DOF</TableHeaderCell>
                  <TableHeaderCell>Current</TableHeaderCell>
                  <TableHeaderCell>Tenure</TableHeaderCell>
                  <TableHeaderCell>Efficency</TableHeaderCell>
                  <TableHeaderCell>Est Hour</TableHeaderCell>
                  <TableHeaderCell>Total Framess</TableHeaderCell>
                  <TableHeaderCell>Target</TableHeaderCell>
                  <TableHeaderCell>ActualTarget</TableHeaderCell>
                  <TableHeaderCell>Productivity %</TableHeaderCell>
                  <TableHeaderCell>Sum of Rejected Frames</TableHeaderCell>
                  <TableHeaderCell>Quality %</TableHeaderCell>
                  <TableHeaderCell>Artifacts Rejected Frames</TableHeaderCell>
                  <TableHeaderCell>Artifacts Rejection %</TableHeaderCell>
                  
                </Table.Row>
              </Table.Header>
              <TableBody >
                {loadData.length === 0 && (
                  <Table.Row>
                    <Table.Cell colSpan={6} textAlign="center">
                      Currently Data not Available
                    </Table.Cell>
                  </Table.Row>
                )}
                {loadData.map((item, index) => (
                
                  <TableRow key={index}>
                    <TableCell>{item.employee_Id}</TableCell>
                    <TableCell>{item.employee_Name}</TableCell>
                    <TableCell>{item.project_Name}</TableCell>
                    <TableCell>{item.approval_Frames}</TableCell>
                    <TableCell>{item.total_Hours}</TableCell>
                    <TableCell>{item.dof}</TableCell>
                    <TableCell>{item.current}</TableCell>
                    <TableCell>{item.tenure}</TableCell>
                    <TableCell>{item.efficency}</TableCell>
                    <TableCell>{item.est_Hour}</TableCell>
                    <TableCell>{item.total_Framess}</TableCell>
                    <TableCell>{item.target}</TableCell>
                    <TableCell>{item.actualTarget}</TableCell>
                    <TableCell>{item.productivity_percentage}</TableCell>
                    <TableCell>{item.sum_of_Rejected_Frames}</TableCell>
                    <TableCell>{item.quality_percentage}</TableCell>
                    <TableCell>{item.artifacts_Rejected_Frames}</TableCell>
                    <TableCell>{item.artifacts_Rejection_percentage}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </div>
            }
        </div>
        
      </>
    )
  }

export default RestorationProductivityReport